<template>
    <div v-if="post">


      <fieldset>
        <label>ID</label>
        <input type="text" v-model="post.document_id" readonly />
      </fieldset>

      <fieldset style="display: flex; align-items: center;">
          <input type="checkbox" class="toggle-switch__input" id="published" v-model="post.published" :value="true" >
          <label class="toggle-switch__label toggle-switch__label--large toggle-switch__label--green-red" for="published">
          </label>
          <label style="padding-left: 10px;">
              Published
          </label>
      </fieldset>


      <fieldset>
        <label>Youtube ID</label>
        <input type="text" v-model="post.youtube_id"  />
      </fieldset>

      <fieldset>
        <label>Instagram URL</label>
        <input type="text" v-model="post.instagram_url"  />
      </fieldset>

      <fieldset>
        <label>Tiktok URL</label>
        <input type="text" v-model="post.tiktok_url"  />
      </fieldset>

      <fieldset>
        <label>Audio</label>
        <input type="text" v-model="post.audio" readonly  />
      </fieldset>

      <fieldset>
        <label>Title</label>
        <input type="text" v-model="post.title" readonly  />
      </fieldset>

      <fieldset>
        <label>Tags</label>
        <input type="text" v-model="post.tags" readonly  />
      </fieldset>

      <fieldset>
        <label>Description</label>
        <textarea v-model="post.description" rows="30" readonly></textarea>
      </fieldset>

      <a class="button" @click="save__clicked">Save Page</a>

      <br /><br /><br />
    </div>
</template>


<script>
  import SocialPost from '../../../models/SocialPost'



  export default {
    data(){
      return{
        post: null,
      }
    },
    async mounted(){
      this.post = await SocialPost.get(this.post_id);
    },
    computed:{
      post_id(){
        return this.$route.params.id;
      }
    },
    methods: {
      async save__clicked(event) {
        await this.post.save();
        alert("Post Saved");
      }
    }
  }
</script>

